declare global {
  interface Window {
    GoogleAnalyticsObject?: any;
    ga?: any;
  }
}

export const initGoogleAnalytics = (measurementId, user) => {
  const currdate : any = new Date();

  /* tslint:disable */
  (function(i,s,o,g,r,a:any,m:any){i.GoogleAnalyticsObject=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*currdate;a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga', {}, {});
  const ga = window.ga;
  ga('create', measurementId, 'auto', {
    'userId': `${user.organisationId}_${user.email}`,
  });
  ga('send', 'pageview');
  ga('config', measurementId);
};

export const sendEvent = (eventCategory, eventAction, eventLabel?, eventValue?) => {
  const ga = window.ga;
  if (ga) {
    ga('send', {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      hitType: 'event',
    });
  }
};

export const EventCategories = {
  RFQ_PLAN: 'RFQ Plan',
  RFQ_LINE_ITEM: 'RFQ Line Item',
  RFQ_ROUND: 'RFQ Round',
  BL_ADDITION: 'BL addition',
  DOWNLOAD_BL: 'Download BL',
  INQUIRY_CREATION: 'Inquiry Creation',
  INQUIRY_SEND: 'Inquiry Send',
  INQUIRY_BIDDING: 'Inquiry Bidding',
  INQUIRY_BID_CONFIRMATION: 'Inquiry Bid Confirmation',
  INQUIRY_BOOKING_SHIPPER: 'Inquiry Booking Shipper',
  INQUIRY_BOOKING_FF: 'Inquiry Booking FF',
  RATE_MASTER: 'Rate Master',
  MARKUP_AUTOMATION_TOOL: 'Markup Automation Tool',
  DISCOVER_RATES_SEARCH_SHIPPER: 'Discover Rates Search Shipper',
  DISCOVER_RATES_SEARCH_FF: 'Discover Rates Search FF',
  DISCOVER_RATES_NEGOTIATE_SHIPPER: 'Discover Rates Negotiate Shipper',
  DISCOVER_RATES_BOOKING_SHIPPER: 'Discover Rates Booking Shipper',
  INQUIRY_REPORTS: 'Inquiry Reports'
};
